import { Box, Grid } from "@mui/material";
import { useApp, useTheme } from "contexts";
import { Custom, Item } from "components";
import { Technologies } from "assets/data";
import { TechnologyType } from "types";

type Props = {};

export const Technology = (props: Props) => {
  const { t } = useApp();
  const { theme } = useTheme();

  const reduced = Technologies.reduce((acc: any, item: TechnologyType) => {
    Object.keys(item.techs).forEach((key: string) => {
      acc[key] = item.techs[key];
    });
    return acc;
  }, {});

  const sorted = Object.keys(reduced).sort((a, b) => reduced[b] - reduced[a]);

  return (
    <Box
      component="section"
      id="tech_arsenal"
      sx={{ pt: { xs: theme.spacing.xl, md: theme.spacing.xxl }, pb: theme.spacing.sm, width: "100%", position: "relative" }}
    >
      {/* Section Header */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "flex-start", md: "flex-end" },
          justifyContent: "space-between",
          mb: theme.spacing.xl,
          gap: theme.spacing.sm,
        }}
      >
        <Box>
          <Box
            sx={{
              fontFamily: '"Space Mono", monospace',
              fontSize: theme.font.xxs,
              fontWeight: theme.font.bold,
              color: theme.color.primary.color,
              letterSpacing: "0.1em",
              textTransform: "uppercase",
            }}
          >
            {t.sections?.tech_badge || "SECTION 02 // TECHNICAL ARSENAL"}
          </Box>
          <Custom.Typography
            variant="h2"
            sx={{
              fontSize: { xs: theme.font.xl, md: theme.font.xxl },
              fontWeight: theme.font.extraBold,
              letterSpacing: "-0.02em",
              mt: theme.spacing.xxs,
            }}
          >
            {t.title.tech_arsenal}
          </Custom.Typography>
        </Box>
        <Box
          sx={{
            fontFamily: '"Space Mono", monospace',
            fontSize: theme.font.xxs,
            color: theme.color.font.accent,
          }}
        >
          {sorted.length} {t.sections?.repo_sync ? "VERIFIED MODULES" : "MODULES"}
        </Box>
      </Box>

      {/* Tech Cards Grid */}
      <Grid container spacing={theme.spacing.sm}>
        {sorted.map((item: string, i: number) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={i}>
            <Item.Technology item={item} count={reduced[item]} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};